import { CART_RECEIVE, CART_SHOW_INFO, CART_OPEN_MINICART } from '../constants';

export const cart = (
    state = { quantity: 0, orderTotal: 0, showInfo: false, miniCartOpenCount: 0 },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
            return {
                ...state,
                ...action.payload,
            };
        case CART_OPEN_MINICART:
            return {
                ...state,
                // The cart state is preloaded from the server and lacks this field on first load.
                miniCartOpenCount: (state.miniCartOpenCount || 0) + 1,
            };
        default:
            return state;
    }
};
